import type { SyncedPrefs } from '@actual-app/core/types/prefs';

// Formatos por defecto para los idiomas de España (H09). Upstream da por hecho
// el formato de EE. UU. (MM/dd/yyyy, semana en domingo, 1,000.33), así que el
// 4 de octubre salía como 10/04/2026 y podía fecharse mal un gasto real.
const IDIOMAS_ESPANA = ['es', 'ca'];

export const FORMATOS_ESPANA = {
  dateFormat: 'dd/MM/yyyy',
  firstDayOfWeekIdx: '1',
  numberFormat: 'dot-comma',
} as const satisfies SyncedPrefs;

/** ¿El idioma (BCP 47: «es», «es-ES», «ca»…) es castellano o catalán? */
export function esIdiomaDeEspana(idioma: string | null | undefined): boolean {
  if (!idioma) return false;
  const base = idioma.toLowerCase().split(/[-_]/)[0];
  return IDIOMAS_ESPANA.includes(base);
}

/**
 * Rellena con los formatos de España las preferencias que aún no se han
 * guardado nunca. Solo toca el estado en memoria: lo que ya eligió el usuario
 * (aunque sea el formato de EE. UU.) no se sobrescribe ni se escribe en disco.
 */
export function conFormatosRegionales(
  synced: SyncedPrefs,
  idioma: string | null | undefined,
): SyncedPrefs {
  if (!esIdiomaDeEspana(idioma)) return synced;
  const resultado: SyncedPrefs = { ...synced };
  for (const [clave, valor] of Object.entries(FORMATOS_ESPANA) as Array<
    [keyof typeof FORMATOS_ESPANA, string]
  >) {
    if (!resultado[clave]) {
      resultado[clave] = valor;
    }
  }
  return resultado;
}
